import { DataAccess } from "../dataaccess/data.access";
import { S25WsMicroOrganization } from "./MicroServices/S25WsMicroOrganization";
import { MicroUtil } from "./MicroServices/micro.util";
import { S25ItemI } from "../pojo/S25ItemI";
import { S25Util } from "../util/s25-util";

export type OrganizationIncludes = "attributes" | "categories" | "organization_types" | "ratings" | "contacts" | "all";
export class OrganizationMicroService {
    public static async getOrganizationIncludes(
        itemIds: number[],
        includes: OrganizationIncludes[],
        expand: boolean = true,
    ) {
        if (S25Util.array.isEmpty(itemIds)) {
            return Promise.resolve<S25WsMicroOrganization.Content>({
                data: {
                    items: [] as S25WsMicroOrganization.Item[],
                },
                expandedInfo: [] as S25WsMicroOrganization.ExpandedInfo[],
            });
        }

        // Fetch organization details with specific includes
        if (includes.includes("all")) {
            includes = ["all"];
        }
        const resp = await DataAccess.get<S25WsMicroOrganization.ContentWrapper>(
            DataAccess.injectCaller(
                `/micro/organization/${itemIds.join("+")}/detail.json?${expand ? "expand=all&" : ""}include=${includes.join("+")}`,
                "OrganizationMicroService.getOrganizationIncludes",
            ),
        );

        return resp.content;
    }

    public static async saveOrganization(
        payload: Partial<S25WsMicroOrganization.Item>,
    ): Promise<S25WsMicroOrganization.ContentWrapper> {
        // Save the organization using the payload provided
        return DataAccess.put<S25WsMicroOrganization.ContentWrapper>(
            DataAccess.injectCaller(`/micro/organization/list.json`, "OrganizationMicroService.saveOrganization"),
            MicroUtil.wrapPayloadItem(payload),
        );
    }

    public static async alterContacts(
        orgIds: number[],
        primaryId: number,
        contacts?: S25ItemI[],
        removedContacts?: S25ItemI[],
    ) {
        const item: Partial<S25WsMicroOrganization.Item> = {
            idList: orgIds,
            primeContact: primaryId,
            contacts: contacts?.map((item) => {
                return { contactId: +item.itemId!, contactRoleId: +item.roleId };
            }),
            remove: {
                contacts: removedContacts?.map((contact) => {
                    return {
                        contactId: +contact.itemId!,
                        contactRoleId: contact.roleId,
                    };
                }),
            },
        };

        const [resp, error] = await S25Util.Maybe(
            OrganizationMicroService.saveOrganization(S25Util.deleteUndefDeep(item)),
        );
        if (error) {
            return Promise.reject(error.content?.error?.message || "Error occurred while saving organization");
        }
        return resp?.content;
    }
}
